// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ProductGridContainerStyle } from "@guestsupply/App/Components/Product/ProductGridContainer";
import ProductListContainer from "@guestsupply/App/Components/Product/ProductListContainer";
import ProductPriceAndActions, {
    ProductPriceAndActionsStyle,
} from "@guestsupply/App/Components/Product/ProductPriceAndActions";
import { mergeWithCss } from "@guestsupply/XDL/Utilities";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import ProductSearchScoreData from "@insite/content-library/Components/ProductSearchScoreData";
import { ProductCardSelections } from "@insite/content-library/Widgets/ProductList/ProductCardSelections";
import ProductListActions from "@insite/content-library/Widgets/ProductList/ProductListActions";
import ProductListProductImage, {
    ProductListProductImageStyles,
} from "@insite/content-library/Widgets/ProductList/ProductListProductImage";
import ProductListProductInformation, {
    ProductListProductInformationStyles,
} from "@insite/content-library/Widgets/ProductList/ProductListProductInformation";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import React, { FC, useState } from "react";
import { css } from "styled-components";

export interface ProductCardProps {
    extendedStyles?: ProductListProductCardStyles;
    showOverlayBadges?: boolean;
    isUpSellsmodal?: boolean;
}
type Props = ProductCardSelections & HasProduct & ProductCardProps;
export interface ProductListProductCardStyles {
    gridContainer?: GridContainerProps;
    leftColumnGridItem?: GridItemProps;
    rightColumnGridItem?: GridItemProps;
    rightColumnGridContainer?: GridContainerProps;
    infoGridItem?: GridItemProps;
    actionsGridItem?: GridItemProps;
    searchScoreDataGridItem?: GridItemProps;
    sponsoredText?: TypographyPresentationProps;
    // XNG-Changes
    productListContainerStyles?: ProductGridContainerStyle;
    productListProductImageStyles?: ProductListProductImageStyles;
    productPriceAndActionsStyles?: ProductPriceAndActionsStyle;
    productListProductInformationStyles?: ProductListProductInformationStyles;
}

export const productCardStyles: ProductListProductCardStyles = {};

// XNG-Changes: change structure
const ProductListProductCard: FC<Props> = props => {
    const [styles] = useState(() => mergeWithCss(productCardStyles, props.extendedStyles));
    return (
        <ProductListContainer
            data-test-selector={`productListProductCard${props.product.id}`}
            extendedStyles={styles.productListContainerStyles}
            id={`${props.isUpSellsmodal ? "upsells-productcard" : ""}`}
        >
            <ProductListContainer.Image>
                <ProductListProductImage
                    showImage={props.showImage}
                    showCompare={false}
                    showImageBadge={props.showImageBadges}
                    showTextBadge={props.showTextBadges}
                    extendedStyles={styles.productListProductImageStyles}
                    {...{ isGridView: false }}
                />
            </ProductListContainer.Image>
            <ProductListContainer.Info>
                <ProductListProductInformation
                    showBrand={props.showBrand}
                    showTitle={props.showTitle}
                    showPartNumbers={props.showPartNumbers}
                    showAvailability={props.showAvailability}
                    showAttributes={props.showAttributes}
                    showImageBadges={props.showImageBadges}
                    maxImageBadges={props.maximumNumberOfImageBadges}
                    showTextBadges={props.showTextBadges}
                    maxTextBadges={props.maximumNumberOfTextBadges}
                />
                <ProductSearchScoreData />
            </ProductListContainer.Info>
            <ProductListContainer.PriceAndActions>
                <ProductPriceAndActions
                    showAvailability={props.showAvailability}
                    showAddToList={props.showAddToList}
                    showPrice={props.showPrice}
                    showCompare={props.showCompare}
                    showDisabled={true}
                    isPlp={true}
                    extendedStyles={styles.productPriceAndActionsStyles}
                    showReplacements={true}
                />
            </ProductListContainer.PriceAndActions>
        </ProductListContainer>
    );
};

export default withProduct(ProductListProductCard);
